import { render, staticRenderFns } from "./wallet_out.vue?vue&type=template&id=705faf48&scoped=true"
import script from "./wallet_out.vue?vue&type=script&lang=js"
export * from "./wallet_out.vue?vue&type=script&lang=js"
import style0 from "./wallet_out.vue?vue&type=style&index=0&id=705faf48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705faf48",
  null
  
)

export default component.exports